const StoryPlayer = {
  __ANIMATION_DURATION: 5000,
  mounted(){
    this._photos = this.el.querySelectorAll('[js-id=story-photo]')
    this.launch()
  },
  destroyed() {
    this._isActive = false
  },
  launch(){
    this._isActive = true
    setTimeout(() => {
      this._photos[0].classList.remove('hidden')
      this._photos[0].classList.remove('scale-150')
      this._photos[0].classList.remove('opacity-0')
      if (this._photos.length > 1)
        this._startProgressBar(this._photos[0])
      this.currentPhoto = 0;
    }, 100)
    setTimeout(this._nextPhoto.bind(this), this.__ANIMATION_DURATION)
  },
  _nextPhoto(){
    if (this._isActive && this.currentPhoto < this._photos.length -1) {
      this._photos[this.currentPhoto].classList.add('hidden')
      this.currentPhoto += 1
      this._photos[this.currentPhoto].classList.remove('hidden')
      this._photos[this.currentPhoto].classList.remove('opacity-0')
      this._photos[this.currentPhoto].classList.remove('scale-150')
      this._startProgressBar(this._photos[this.currentPhoto])
      setTimeout(this._nextPhoto.bind(this), this.__ANIMATION_DURATION)
    } else {
      //this.pushEvent("story_end")
    }
  },
  _startProgressBar(div) {
    let progressBar = div.querySelector('[js-id=progress-bar]')
    progressBar.className = "bg-black rounded-full bg-opacity-80 h-2 mt-2 absolute left-2 right-2"
    let progressBarContainer = document.createElement('div')
    progressBarContainer.style = ` animation-duration: ${this.__ANIMATION_DURATION}ms;`
    progressBarContainer.className = "bg-white w-0 rounded-full h-2 absolute animate-progress"
    progressBar.appendChild(progressBarContainer)
  }
}

export default { StoryPlayer }
